const enTranslations = {
  menu: {
    about: "About Us",
    services: "Services",
    partners: "Partners",
    contacts: "Contacts"
  },

  aboutInfo: {
    title: "Who We Are",
    description: " Our team specializes in the design and implementation of security systems.",
    main: "“Hover Systems” LLC was founded in 2022. Our team specializes in the design and implementation of security systems, including fire alarm systems, voice evacuation systems, access control, video surveillance, staff call systems, hotel locks, and telecommunication systems. The engineering staff of the company has around 15 years of experience in the field of security systems and has obtained multiple certifications from leading European brands during this time."
  },

  services: {
    title: "Services",
    description: "We implement our best with our high qualified specialists",
    service1: "Fire alarm systems",
    service2: "Fire gas extinguishing systems",
    service3: "Voice evacuation systems",
    service4: "Intrusion detection system",
    service5: " Access control systems",
    service6: " Electronic hotel locks",
    service7: "Energy-saving systems for hotels",
    service8: "Staff Call Systems",
    service9: "Local computer and telecommunications",
    service10: "CCTV",
  },

  companies: {
    title: "Companies",
    description: "Companies we work with",
  },
  
  contacts: {
    title: "Our Contacts",
    description: "Please feel free to contact us with any questions.",
    founder: "Hovhannes H. Alaverdyan",
    position: "Founder and Director of “Hover Systems” LLC",
    addressLabel: "Address:",
    address: "Armenia, Yerevan, Mamikonyants 27",
    telLabel: "Tel:",
    tel: "+374 95 64 61 23",
    emailLabel: "E-mail:",
    email: "info@hoversystems.am",
    email2: "hoversystemsarmenia@gmail.com"
  },
};

export default enTranslations;
